import { render, staticRenderFns } from "./userChannel.vue?vue&type=template&id=30bd10c5&scoped=true&"
import script from "./userChannel.vue?vue&type=script&lang=js&"
export * from "./userChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bd10c5",
  null
  
)

export default component.exports